import { CustomerReport } from '@api/order-reporting/types-deliveries/DeliveriesReports';
import { CustomerReportGridData } from '@pages/reporting-pages/deliveries-customer/types/CustomerReportGridData';
import { valueExist } from '@utils/typescriptGuards';
import { MainTransportTypes } from '@api/order-reporting/types-deliveries/CountryDeliveriesSummaryReport';



export const convertToGridData = (apiData: CustomerReport[] | undefined | null): CustomerReportGridData[] | null => {
	if (!apiData) return null;

	let gridData: CustomerReportGridData[] = [];
	if (apiData.length === 0)
		return gridData;
	
	for (const apiDataItem of apiData) {
		const totalValue = apiDataItem.transportTypesData[MainTransportTypes.total];

		gridData.push({
			onOffTrade: apiDataItem.onOffTrade && apiDataItem.onOffTrade === true ? 'ON Trade' : 'OFF Trade',
			country: apiDataItem.country,
			destinationName: apiDataItem.destinationName,

			total_volume: totalValue && valueExist(totalValue.volume) ? totalValue.volume : 0,
			total_volumePct: totalValue && valueExist(totalValue.volumePct) ? totalValue.volumePct : 0,
			total_weight: totalValue && valueExist(totalValue.weight) ? totalValue.weight : 0,
			total_ordersCount: totalValue && valueExist(totalValue.ordersCount) ? totalValue.ordersCount : 0,
			total_returnsWeight: totalValue && valueExist(totalValue.returnsWeight) ? totalValue.returnsWeight : 0,
		});
	}

	return gridData;
}